import {CREATE_REPORT, DELETE_REPORT, FETCH_STUDENT_REPORTS, FETCH_STUDENT_REPORTS_DATA} from '../constants/report';

export function fetchStudentReports(studentCourseId) {
  return ({
    type: FETCH_STUDENT_REPORTS,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/students/reports',
      params: {'student-course': studentCourseId}
    }
  });
}

export function createReport(data) {
  return ({
    type: CREATE_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/students/reports',
      data
    }
  });
}

export function deleteReport(reportId) {
  return ({
    type: DELETE_REPORT,
    api: true,
    auth: true,
    payload: {
      method: 'DELETE',
      url: `/students/reports/${reportId}`
    },
    data: {reportId}
  });
}

export function fetchStudentReportsData() {
  return ({
    type: FETCH_STUDENT_REPORTS_DATA,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: 'students/reports/data'
    }
  });
}
